export default "__VITE_ASSET__CvN$ZrXN__"